module.exports = "<settings-editor></settings-editor>\n";